var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const vscode = require("vscode-languageserver-protocol");
const shared = require("@volar/shared");
const rename_1 = require("./rename");
const fixNames = require("../utils/fixNames");
const getFormatCodeSettings_1 = require("../configs/getFormatCodeSettings");
const getUserPreferences_1 = require("../configs/getUserPreferences");
function register(rootUri, languageService, getTextDocument, getConfiguration) {
    return (uri, range, context) => __awaiter(this, void 0, void 0, function* () {
        const document = getTextDocument(uri);
        if (!document)
            return;
        const [formatOptions, preferences] = yield Promise.all([
            (0, getFormatCodeSettings_1.getFormatCodeSettings)(getConfiguration, document.uri),
            (0, getUserPreferences_1.getUserPreferences)(getConfiguration, document.uri, rootUri),
        ]);
        const fileName = shared.uriToFileName(document.uri);
        const start = document.offsetAt(range.start);
        const end = document.offsetAt(range.end);
        let result = [];
        const onlyQuickFix = matchOnlyKind(`${vscode.CodeActionKind.QuickFix}.ts`);
        if (!context.only || onlyQuickFix) {
            for (const error of context.diagnostics) {
                try {
                    const codeFixes = languageService.getCodeFixesAtPosition(fileName, document.offsetAt(error.range.start), document.offsetAt(error.range.end), [Number(error.code)], formatOptions, preferences);
                    for (const codeFix of codeFixes) {
                        result = result.concat(transformCodeFix(codeFix, [error], onlyQuickFix !== null && onlyQuickFix !== void 0 ? onlyQuickFix : vscode.CodeActionKind.Empty));
                    }
                }
                catch (_a) { }
            }
        }
        if (context.only) {
            for (const only of context.only) {
                if (only.split('.')[0] === vscode.CodeActionKind.Refactor) {
                    try {
                        const refactors = languageService.getApplicableRefactors(fileName, { pos: start, end: end }, preferences, undefined, only);
                        for (const refactor of refactors) {
                            result = result.concat(transformRefactor(refactor));
                        }
                    }
                    catch (_b) { }
                }
            }
        }
        else {
            try {
                const refactors = languageService.getApplicableRefactors(fileName, { pos: start, end: end }, preferences, undefined, undefined);
                for (const refactor of refactors) {
                    result = result.concat(transformRefactor(refactor));
                }
            }
            catch (_c) { }
        }
        const onlySourceOrganizeImports = matchOnlyKind(`${vscode.CodeActionKind.SourceOrganizeImports}.ts`);
        if (onlySourceOrganizeImports) {
            const action = vscode.CodeAction.create('Organize Imports', onlySourceOrganizeImports);
            action.data = {
                type: 'organizeImports',
                uri,
                fileName,
            };
            result.push(action);
        }
        const onlySourceFixAll = matchOnlyKind(`${vscode.CodeActionKind.SourceFixAll}.ts`);
        if (onlySourceFixAll) {
            const action = vscode.CodeAction.create('Fix All', onlySourceFixAll);
            action.data = {
                uri,
                type: 'fixAll',
                fileName,
                fixIds: [
                    fixNames.classIncorrectlyImplementsInterface,
                    fixNames.awaitInSyncFunction,
                    fixNames.unreachableCode,
                ],
            };
            result.push(action);
        }
        const onlyRemoveUnused = matchOnlyKind(`${vscode.CodeActionKind.Source}.removeUnused.ts`);
        if (onlyRemoveUnused) {
            const action = vscode.CodeAction.create('Remove all unused code', onlyRemoveUnused);
            action.data = {
                uri,
                type: 'fixAll',
                fileName,
                fixIds: [
                    // not working and throw
                    fixNames.unusedIdentifier,
                    // TODO: remove patching
                    'unusedIdentifier_prefix',
                    'unusedIdentifier_deleteImports',
                    'unusedIdentifier_delete',
                    'unusedIdentifier_infer',
                ],
            };
            result.push(action);
        }
        const onlyAddMissingImports = matchOnlyKind(`${vscode.CodeActionKind.Source}.addMissingImports.ts`);
        if (onlyAddMissingImports) {
            const action = vscode.CodeAction.create('Add all missing imports', onlyAddMissingImports);
            action.data = {
                uri,
                type: 'fixAll',
                fileName,
                fixIds: [
                    // not working and throw
                    fixNames.fixImport,
                    // TODO: remove patching
                    'fixMissingImport',
                ],
            };
            result.push(action);
        }
        for (const codeAction of result) {
            if (codeAction.diagnostics === undefined) {
                codeAction.diagnostics = context.diagnostics;
            }
        }
        return result;
        function matchOnlyKind(kind) {
            if (context.only) {
                for (const only of context.only) {
                    const a = only.split('.');
                    const b = kind.split('.');
                    if (a.length <= b.length) {
                        let matchNums = 0;
                        for (let i = 0; i < a.length; i++) {
                            if (a[i] == b[i]) {
                                matchNums++;
                            }
                        }
                        if (matchNums === a.length)
                            return only;
                    }
                }
            }
        }
        function transformCodeFix(codeFix, diagnostics, kind) {
            const edit = (0, rename_1.fileTextChangesToWorkspaceEdit)(codeFix.changes, getTextDocument);
            const codeActions = [];
            const fix = vscode.CodeAction.create(codeFix.description, edit, kind);
            fix.diagnostics = diagnostics;
            codeActions.push(fix);
            if (codeFix.fixAllDescription && codeFix.fixId) {
                const fixAll = vscode.CodeAction.create(codeFix.fixAllDescription, kind);
                fixAll.data = {
                    uri,
                    type: 'fixAll',
                    fileName,
                    fixIds: [codeFix.fixId],
                };
                fixAll.diagnostics = diagnostics;
                codeActions.push(fixAll);
            }
            return codeActions;
        }
        function transformRefactor(refactor) {
            const codeActions = [];
            for (const action of refactor.actions) {
                const codeAction = vscode.CodeAction.create(action.description, action.kind);
                codeAction.data = {
                    uri,
                    type: 'refactor',
                    fileName,
                    range: { pos: start, end: end },
                    refactorName: refactor.name,
                    actionName: action.name,
                };
                if (action.notApplicableReason) {
                    codeAction.disabled = { reason: action.notApplicableReason };
                }
                if (refactor.inlineable) {
                    codeAction.isPreferred = true;
                }
                codeActions.push(codeAction);
            }
            return codeActions;
        }
    });
}
exports.register = register;
//# sourceMappingURL=codeAction.js.map